import React from 'react';

function RebateInfo({ displayRate, currency }) {
  return (
    <p className="mn_rebateInfo">
      Earn {displayRate} {currency} <span className="mn_suffix">in store</span>
    </p>
  );
}

export default RebateInfo;
